import './Text.css';
import React, { useState } from 'react';

export function MotionReel() {
    const [ttttA2V_csY] = useState('ttttA2V_csY')
    return (
    <div class="body">
      <div class="row" >


<iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${ttttA2V_csY}?autoplay=0`}>
</iframe>


      
      </div>
    
    </div>



  );
}
